<template lang="pug">
.breakdown
    Invoices(:invoices="invoices" :columns="invoicesColumns" v-on="$listeners" :selectedInvoices="selectedInvoices")
    Payments(:invoices="selectedInvoices" :columns="paymentsColums")
</template>

<script>
export default {
  name: 'DashboardBreakdown',
  data: () => ({
    invoicesColumns: [
      {
        label: 'folio',
        value: 'folio'
      },
      {
        label: 'date',
        value: 'created_at'
      },
      {
        label: 'amount',
        value: 'amount'
      }
    ],
    paymentsColums: [
      {
        label: 'id',
        value: 'id'
      },
      {
        label: 'date',
        value: 'created_at'
      },
      {
        label: 'amount',
        value: 'amount'
      }
    ]
  }),
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    selectedInvoices: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Invoices: () =>
            import('@/components/in-order/Payments/Dashboard/Breakdown/Invoices.vue'),
    Payments: () =>
            import('@/components/in-order/Payments/Dashboard/Breakdown/Payments.vue')
  }
}
</script>

<style lang="scss">
.breakdown {
    display: flex;
    justify-content: space-around;
    padding: 1rem 0;
}
</style>
